import { AddCustomPartListRequest, TmaEModule } from "@tm/models"
import { TmaHelper } from "@tm/utils"
import { WorkTaskInfo } from "@tm/context-distribution"
import { BasicBasketPartInfo } from "../../../../../models"
import { CostEstimation } from "../../../../../data/model"
import { useBasketMemo } from "../../../../../hooks/useBasketMemo"
import { CustomPartEditDialog } from "./PartEdit/CustomPartEditDialog"

type Props = {
    workTask: WorkTaskInfo
    costEstimation?: CostEstimation
    currencyCode: string
    disableHeaderButtons?: boolean
    onAddCustomPart(request: AddCustomPartListRequest): void
    onClose(): void
}

export function NewCustomPartDialog({ currencyCode, costEstimation, workTask, disableHeaderButtons, onAddCustomPart, onClose }: Props) {
    const { id, customer, vehicle } = workTask
    const { customerDefaults, costEstimationOptions } = costEstimation || {}

    const basketMemo = useBasketMemo(workTask)

    async function handleAddCustomPart(basicBasketPartInfo: BasicBasketPartInfo, quantityValue: number) {
        const { description, partNumber, purchasePrice, retailPrice, rebate, surcharge, vatRate } = basicBasketPartInfo
        onAddCustomPart({
            workTaskId: id,
            customParts: [
                {
                    articleNumber: partNumber,
                    retailPrice,
                    purchasePrice,
                    description: description ?? "",
                    quantityValue,
                    rebate,
                    surcharge,
                    vatRate,
                    memo: basketMemo.position,
                },
            ],
            vehicleId: vehicle?.id,
            customerId: customer?.id,
            usePercentageValues: true,
            log: TmaHelper.AddCustomToBasket.GetUserInteractionLog("customArticle", TmaEModule.ARTICLE_COMPILATIONS),
            costEstimationOptions,
        })
    }

    return (
        <CustomPartEditDialog
            disableHeaderButtons={disableHeaderButtons}
            customPartInfo={{
                type: "add",
            }}
            currencyCode={currencyCode}
            costEstimationOptions={costEstimationOptions}
            customerDefaults={customerDefaults}
            onCloseButtonClick={onClose}
            onAddCustomPart={handleAddCustomPart}
        />
    )
}
